import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Admin from '@/components/Admin'
import Index from '@/components/Index'

import Lawyer from '@/router/lawyer'
import System from '@/router/system'
import Video from '@/router/video'
import Notice from '@/router/notice'

Vue.use(Router)

// let routes = [{
//   path: '/login',
//   name: 'Login',
//   component: Login
// }, {
//   path: '/',
//   name: 'HelloWorld',
//   component: HelloWorld,
//   children: [{
//     path: 'laywer',
//     name: 'Laywer',
//     component: Laywer
//   }, ...System, ...Video]
// }]
let routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },{
    path: '/',
    name: 'Admin',
    component: Admin,
    children: [{
      path: 'index',
      name: 'Index',
      component: Index
    }, ...System, ...Video, ...Lawyer, ...Notice]
  }
  // }, {
  //   path: '/',
  //   name: 'Admin',
  //   component: Admin
  // }, {
  //   path: '/helloWorld',
  //   name: 'HelloWorld',
  //   component: HelloWorld
  // }, ...System, ...Video, ...Lawyer
]
export default new Router({
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js